module.exports = __webpack_public_path__ + "img/paypal_checkout.27c6deb6.png";